module.exports = __webpack_public_path__ + "img/3Shape1.4f62c23f.png";